import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AuthModule as Auth0Module } from '@auth0/auth0-angular';
import { AnalyticsModule } from '@techspert-io/analytics';
import { AuthModule } from '@techspert-io/auth';
import { ErrorHandlingModule } from '@techspert-io/error-handling';
import { GrowthbookModule } from '@techspert-io/growthbook';
import { ProjectKeywordsModule } from '@techspert-io/project-keywords';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OmnisearchModule } from './features/omnisearch/omnisearch.module';
import { PatternsModule } from './features/patterns/patterns.module';
import { PrivateModule } from './private/private.module';
import { PublicModule } from './public/public.module';
import { TopBarModule } from './shared/components/top-bar/top-bar.module';

@NgModule({
  imports: [
    PrivateModule,
    BrowserAnimationsModule,
    PublicModule,
    ReactiveFormsModule,
    AppRoutingModule,
    RouterModule,
    TopBarModule,
    AnalyticsModule.forRoot(environment.gaMeasurementId),
    AuthModule.forRoot(environment.auth0.domain, environment.connectApiBaseUrl),
    Auth0Module.forRoot({
      ...environment.auth0,
      useRefreshTokens: true,
      cacheLocation: 'localstorage',
      authorizationParams: {
        ...environment.auth0.authorizationParams,
        redirect_uri: window.location.origin,
      },
    }),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
    }),
    GrowthbookModule.forRoot(),
    ErrorHandlingModule.forRoot(environment.raygunApiKey),
    OmnisearchModule,
    PatternsModule,
    ProjectKeywordsModule,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private iconRegistry: MatIconRegistry) {
    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
  }
}
